import type { GroupedNode } from '@/hooks/useGroupedRequirements'
import type { NotesSharedProps } from './notesShared'
import { NotesEpic } from './NotesEpic'
import { NotesStory } from './NotesStory'

/** Dispatches a grouped tree node to its type-specific block component. */
export function NotesNode({ node, ...shared }: NotesSharedProps & { node: GroupedNode }) {
  const r = node.requirement
  if (r.type === 'story') return <NotesStory requirement={r} {...shared} />
  // Both 'epic' and 'nfr-category' render as section-grouped epic blocks.
  if (r.type === 'epic' || r.type === 'nfr-category') return <NotesEpic node={node} {...shared} />
  return null
}
